import { render, staticRenderFns } from "./veggiesbonanza.vue?vue&type=template&id=4d5f54aa"
import script from "./veggiesbonanza.vue?vue&type=script&lang=js"
export * from "./veggiesbonanza.vue?vue&type=script&lang=js"
import style0 from "./veggiesbonanza.vue?vue&type=style&index=0&id=4d5f54aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports